
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ebQs8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6acfeefbccb1db81$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $6acfeefbccb1db81$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "Tilf\xf8j din egen emoji",
    'fabric.emoji.add.label': "Tilf\xf8j emoji",
    'fabric.emoji.cancel.label': "Annull\xe9r",
    'fabric.emoji.categories.label': "V\xe6lg en emoji-kategori",
    'fabric.emoji.categories.search.results': "S\xf8geresultater",
    'fabric.emoji.category.activity': 'Aktivitet',
    'fabric.emoji.category.all.uploads': 'Alle uploads',
    'fabric.emoji.category.flags': 'Flag',
    'fabric.emoji.category.foods': 'Mad og drikke',
    'fabric.emoji.category.frequent': 'Ofte benyttede',
    'fabric.emoji.category.nature': 'Natur',
    'fabric.emoji.category.objects': 'Objekter',
    'fabric.emoji.category.people': 'Personer',
    'fabric.emoji.category.places': 'Rejser og steder',
    'fabric.emoji.category.productivity': 'Produktivitet',
    'fabric.emoji.category.symbols': 'Symboler',
    'fabric.emoji.category.user.uploads': 'Dine uploads',
    'fabric.emoji.choose.file.screenReaderDescription': "V\xe6lg en fil til emojien. JPG, PNG eller GIF. Maks. st\xf8rrelse: 1\xa0MB",
    'fabric.emoji.choose.file.title': "V\xe6lg fil",
    'fabric.emoji.delete.description': 'Alle eksisterende forekomster af denne emoji erstattes med  {emojiShortName}',
    'fabric.emoji.delete.label': 'Fjern',
    'fabric.emoji.delete.screenreader.tooltip': "Tryk p\xe5 Tilbage for at slette {shortName}-emoji'en",
    'fabric.emoji.delete.title': 'Fjern emoji',
    'fabric.emoji.delete.tooltip': 'Slet',
    'fabric.emoji.emojipicker.emoi.roledescription': 'emojiknap',
    'fabric.emoji.emojipicker.error': 'Fejl!',
    'fabric.emoji.error.delete.failed': 'Fjern mislykkede',
    'fabric.emoji.error.image.too.big': "Det valgte billede er st\xf8rre end 1 MB",
    'fabric.emoji.error.invalid.image': 'Det valgte billede er ugyldigt',
    'fabric.emoji.error.upload.failed': 'Upload mislykkedes',
    'fabric.emoji.error.upload.timeout': 'Upload fik timeout',
    'fabric.emoji.image.requirements': "JPG, PNG eller GIF. Maks. st\xf8rrelse 1 MB.",
    'fabric.emoji.name.ariaLabel': 'Angiv et navn til den nye emoji',
    'fabric.emoji.picker': "Emojiv\xe6lger",
    'fabric.emoji.pickerlist.grid': "{showSearchResults, select, true {S\xf8geresultater} other {Emojis}}",
    'fabric.emoji.pickerlist.tabpanel': 'Emoji-handlinger og listepanel',
    'fabric.emoji.placeholder': 'fx hej',
    'fabric.emoji.preview': 'Din nye emoji {emoji} ser flot ud',
    'fabric.emoji.preview.title': 'Vis',
    'fabric.emoji.retry.label': "Pr\xf8v igen",
    'fabric.emoji.search.label': 'Emojinavn',
    'fabric.emoji.search.placeholder': "S\xf8g",
    'fabric.emoji.search.status': 'Viser alle emojis',
    'fabric.emoji.select.skin.list.ariaLabel': "Hudfarvev\xe6lger",
    'fabric.emoji.select.skin.tone.ariaLabel': "V\xe6lg din hudfarve, {selectedTone} valgt"
};

});


//# sourceMappingURL=da.0b8f5f72.js.map
